import { useState } from "react";
import { Sidebar } from "../SideBar";
import Dashboard from "../ui/Dashboard";

export default function EmployeeLayout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-background/50">
      <Sidebar open={open} setOpen={setOpen} />
      <div className="flex-1 bg-[#FFFF]">
        <div>
          <Dashboard setOpen={setOpen} />
          <main className="flex-1 pt-[52px] xs:pt-[56px] rs:pt-[72px]">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}